import { useEffect, useState } from 'react';

const currentFullscreenElement = () => (
  typeof document !== 'undefined' ? document.fullscreenElement || null : null
);

/**
 * Das aktuelle Vollbild-Element (z. B. die LiveMap) oder null.
 *
 * Im Vollbild zeigt der Browser nur dieses Element. Hinweise, die sonst am
 * <body> hängen (Anruf, kritische Meldung), müssen dann dort hinein gerendert
 * werden, sonst sieht sie niemand – etwa wenn nur ein Portal-Fenster offen
 * ist und die LiveMap im Vollbild läuft.
 */
const useFullscreenElement = () => {
  const [element, setElement] = useState(currentFullscreenElement);

  useEffect(() => {
    const update = () => setElement(currentFullscreenElement());
    document.addEventListener('fullscreenchange', update);
    return () => document.removeEventListener('fullscreenchange', update);
  }, []);

  return element;
};

export default useFullscreenElement;
